// src/pages/Receita/ReceitaList.jsx

import React, { useEffect, useState } from 'react';
import DataTable from '../../components/DataTablePtBr';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/Header';
import api from '../../services/api';
import { showError, showConfirmation, showSuccess } from '../../services/alert';

const ReceitaList = () => {
  const [receitas, setReceitas] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const fetchReceitas = async () => {
    setLoading(true);
    try {
      const res = await api.get('/receita');
      setReceitas(res.data);
    } catch (err) {
      console.error('Erro ao buscar receitas:', err);
      showError('Erro ao buscar receitas.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchReceitas();
  }, []);

  const handleDelete = async (id) => {
    const confirmou = await showConfirmation({
      title: 'Excluir receita?',
      text: 'Tem certeza que deseja apagar esta receita?',
      confirmText: 'Sim, excluir',
      cancelText: 'Cancelar',
    });
    if (!confirmou) return;

    try {
      await api.delete(`/receita/${id}`);
      showSuccess('Receita excluída com sucesso.');
      fetchReceitas();
    } catch (err) {
      console.error('Erro ao excluir receita:', err);
      showError(err.response?.data?.message || 'Erro ao excluir receita.');
    }
  };

  const columns = [
    {
      name: 'Descrição',
      selector: row => row.descricao,
      sortable: true,
    },
    {
      name: 'Valor (R$)',
      selector: row => Number(row.valor).toFixed(2),
      sortable: true,
      right: true,
    },
    {
      name: 'Data',
      selector: row => new Date(row.dataRecebimento).toLocaleDateString(),
      sortable: true,
    },
    {
      name: 'Safra',
      selector: row => row.safra || '-',
      sortable: true,
    },
    {
      name: 'Categoria',
      selector: row => row.categoriaFinanceira,
      sortable: true,
    },
    {
      name: 'Ações',
      cell: row => (
        <div className="d-flex gap-1">
          <button
            className="btn btn-outline-success btn-sm d-flex align-items-center gap-1"
            onClick={() => navigate(`/receita/${row.id}`)}
          >
            <i className="bi bi-pencil-square"></i>
            <span>Editar</span>
          </button>
          <button
            className="btn btn-outline-danger btn-sm d-flex align-items-center gap-1"
            onClick={() => handleDelete(row.id)}
          >
            <i className="bi bi-trash"></i>
            <span>Excluir</span>
          </button>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      minWidth: '160px',
      style: { whiteSpace: 'nowrap' },
    }
  ];

  return (
    <div className="container mt-4">
      <Header />
      <div className="card shadow-lg border-0 rounded-3">
        <div className="card-header bg-success text-white d-flex justify-content-between align-items-center rounded-top-3">
          <div className="d-flex align-items-center gap-3">
            <button
              className="btn btn-light btn-sm d-flex align-items-center gap-1"
              onClick={() => navigate('/menu')}
            >
              <i className="bi bi-arrow-left text-success"></i>
              <span className="text-success fw-semibold">Voltar</span>
            </button>
            <div>
              <h5 className="mb-0">Receitas</h5>
              <small className="text-white-50">Lançamentos de Receita</small>
            </div>
          </div>
          <button
            className="btn btn-light text-success fw-bold d-flex align-items-center gap-1"
            onClick={() => navigate('/receita/novo')}
          >
            <i className="bi bi-plus-circle"></i>
            <span>Nova Receita</span>
          </button>
        </div>
        <div className="card-body">
          <DataTable
            columns={columns}
            data={receitas}
            pagination
            responsive
            highlightOnHover
            striped
            progressPending={loading}
            noDataComponent={<div className="text-muted">Nenhuma receita encontrada.</div>}
          />
        </div>
      </div>
    </div>
  );
};

export default ReceitaList;
